import _ from "lodash";
import React from "react";
import { Viz } from "tableau-js-api/viz";
import { FilterEvent, ParameterEvent, TabSwitchEvent } from "tableau-js-api/viz.event";

let _viz: React.MutableRefObject<Viz | null> | null = null

export function getViz(): React.MutableRefObject<Viz | null> | null {
    return _viz
}

export function setViz(viz: React.MutableRefObject<Viz | null> | null) {
    _viz = viz
}

export function getCurrentViz(): Viz | null {
    if (!_.isNil(getViz())) {
        const viz = getViz()!.current
        if (viz) {
            return viz
        }
    }
    return null
}

export interface TableauEventListener {
    onEvent: (data: object) => void
}

let _listeners: TableauEventListener[] = []
export const vizEventListener = (event: TabSwitchEvent | FilterEvent | ParameterEvent) => {
    _listeners.forEach(i => i.onEvent(event))
}

export function addVizListener(listener: TableauEventListener) {
    _listeners.push(listener)
}

export async function getViewURL(viewName: string): Promise<string> {
    const viz = getCurrentViz()
    if (viz) {
        // save the view with filters, params
        await viz
            .getWorkbook()
            .rememberCustomViewAsync(viewName)

        const savedViews = await viz
            .getWorkbook()
            // @ts-ignore
            .getCustomViewsAsync() as Array<{getName: () => string, getUrl: () => string}>

        return savedViews.find(savedView => savedView.getName() === viewName)!.getUrl()
    }
    throw new Error("Error getting view URL")
}


export async function deleteView(viewName: string) {
    getCurrentViz()?.getWorkbook()?.removeCustomViewAsync(viewName)
}

export function getSheetURL(index: number): any {
    const viz = getCurrentViz()
    if (viz) {
        return viz
            .getWorkbook()
            .getPublishedSheetsInfo()[index]
            .getUrl()
    }
    return null
}